import React, { useCallback, useEffect, useMemo } from "react";
import { useSelector, useDispatch, shallowEqual } from "react-redux";
import ChartDataLabels from "chartjs-plugin-datalabels";
import CardGraph from "../../components/CardGraph/CardGraph";
import { getData } from "../../redux/ducks/pricesBusinessSection";

const options = {
  maintainAspectRatio: false,
  scales: {
    x: {
      offset: true,
    },
  },
  plugins: {
    datalabels: {
      color: "black",
      align: "end",
      labels: {
        title: {
          font: {
            weight: "bold",
          },
        },
      },
    },
  },
};

function PricesBusinessSection() {
  const dispatch = useDispatch();

  const prices = useSelector(
    (state) => state.pricesBusiness.prices,
    shallowEqual
  );
  const graphs = useSelector((state) => state.pricesBusiness.graphs);

  const plugin = useMemo(() => {
    return [ChartDataLabels];
  }, []);

  const fetchData = useCallback(() => {
    dispatch(getData());
  }, [dispatch]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return (
    <>
      <CardGraph
        isVertical
        height={300}
        title="Totales"
        data={prices}
        plugins={plugin}
        options={options}
      />

      {graphs &&
        graphs.map((graph, index) => (
          <React.Fragment key={`${graph.name}-${index}`}>
            <CardGraph
              isVertical
              height={300}
              title={`Historico de Margen ${graph.name}`}
              data={graph}
              plugins={plugin}
              options={options}
            />
          </React.Fragment>
        ))}
    </>
  );
}

export default React.memo(PricesBusinessSection);
